import { __rest } from "tslib";
import React, { useRef, useEffect } from "react";
import cls from "classnames";
import { useVisible } from "@al/rc-util";
const classPrefix = "akui-fixed-top";
export const FixedTop = props => {
  const {
    alwaysFixed,
    top = "0px",
    style,
    height,
    root,
    zIndex = 100,
    children,
    className,
    fixedClassName,
    fixedStyle,
    onFixedChange
  } = props,
        rest = __rest(props, ["alwaysFixed", "top", "style", "height", "root", "zIndex", "children", "className", "fixedClassName", "fixedStyle", "onFixedChange"]);

  const fixedWrapperRef = useRef(null); // 设置监听参数控制：top 为吸顶距离

  const options = {
    rootMargin: `-${top} 0px 0px 0px`,
    // 有root给IntersectionObserver设置root
    root
  }; // 是否悬浮, 该 hooks 不可提取，否则 hooks 会多次触发 render

  const visible = useVisible({
    el: fixedWrapperRef,
    options
  });
  const shouldFixed = alwaysFixed ? true : !visible;
  useEffect(() => {
    onFixedChange && onFixedChange(shouldFixed);
  }, [shouldFixed, onFixedChange]);
  return React.createElement("div", Object.assign({
    style: Object.assign(Object.assign({}, style), {
      height
    })
  }, rest, {
    className: cls(className, shouldFixed && fixedClassName),
    ref: fixedWrapperRef
  }), React.createElement("div", {
    className: classPrefix,
    style: Object.assign({
      height,
      position: shouldFixed ? "fixed" : "initial",
      top,
      zIndex: zIndex
    }, shouldFixed ? fixedStyle : {})
  }, children));
};